import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import analytics from '@repo/analytics';
import { Spacer } from '@repo/ui/components/Spacer';
import { themeStyle } from '@repo/ui/theming';
import { H5, H6, H7 } from '@repo/ui-kit/components/core/Typography';

import { NAVIGATION_AI_TOOLS } from 'global/analyticsEvents';
import { FlexRow, FlexColumn } from 'styles/layouts';

import { HighlightOnHover, MenuItemDescription } from './styles';
import { MenuItemProps } from './types';

const ImageItem: React.FC<MenuItemProps> = (item) => {
  const Header = item.small ? H6 : H5;

  return (
    <FlexRow alignItems="center">
      <Image
        alt={item.label}
        height={50}
        src={item.image!}
        style={{
          borderRadius: themeStyle.radiusSmall,
          backgroundColor: 'unset',
        }}
        width={50}
      />
      <Spacer width="12px" />
      <FlexColumn gap="2px">
        <Header bold as="span" color="inherit">
          {item.label}
        </Header>
        <MenuItemDescription>
          <H7 as="p" color="inherit">
            {item.description}
          </H7>
        </MenuItemDescription>
      </FlexColumn>
    </FlexRow>
  );
};

const MenuItem: React.FC<MenuItemProps> = (item) => {
  const Text = item.small ? H6 : H5;
  const linkContent = (
    <HighlightOnHover>
      {item.image && item.description ? (
        <ImageItem {...item} />
      ) : (
        <Text as="span" color="inherit">
          {item.label}
        </Text>
      )}
    </HighlightOnHover>
  );

  const handleItemClick = (): void => {
    if (item.id) {
      void analytics.track(`${NAVIGATION_AI_TOOLS}_${item.id}`);
    }
    item.onClick?.();
  };

  const linkOptions = item.isAbsolutePath
    ? {
        rel: 'noopener noreferrer',
        target: '_blank',
        onClick: handleItemClick,
      }
    : {
        onClick: handleItemClick,
      };

  return (
    <li>
      <Link href={item.path} {...linkOptions}>
        {linkContent}
      </Link>
    </li>
  );
};

export default MenuItem;
